<template>
  <main class="row q-gutter-x-xs">
    <section class="col">
      <q-table
        style="height: 500px"
        flat
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        :loading="disable"
        :columns="columns"
        class="q-mt-md tabela-tamanho-fixo"
        :rows-per-page-label="'Linhas Por Página'"
        :rows-per-page-options="[10, 25, 50, 100]"
        row-key="id"
        dense
        selection="multiple"
        v-model:selected="rows2"
        color="primary"
        v-model:pagination="pagination"
        @request="handleRequest"
      >
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:top-right>
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filtrar"
            type="text"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>
        <template v-slot:body="props">
          <q-tr>
            <q-td>
              <span>{{ props.row.name }}</span>
            </q-td>
            <q-td>
              <span>{{ props.row.contrato }}</span>
            </q-td>
            <q-td>
              <q-btn
                v-if="props"
                color="secondary"
                dense
                icon="visibility"
                :disable="props.selected"
                round
                @click="vizualizarUnidade(props.row.id)"
              />
            </q-td>
            <q-td>
              <q-btn
                v-if="props"
                color="positive"
                dense
                icon="done"
                round
                @click="finalizarUnidade(props.row.id)"
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </section>
    <section class="col">
      <q-table
        style="height: 500px"
        flat
        dense
        table-header-class="bg-accent text-width-bold"
        :rows="rows2"
        :loading="disable"
        :columns="columns2"
        class="q-mt-md tabela-tamanho-fixo"
        row-key="id"
        color="primary"
        :rows-per-page-label="'Linhas Por Página'"
        :rows-per-page-options="[10, 25, 50, 100]"
        :filter="filtrar2"
      >
        <template v-slot:top-right>
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filtrar2"
            type="text"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>

        <template #body-cell-nome="props">
          <q-td>
            {{ props.row.name }}
          </q-td>
        </template>
        <template #body-cell-remover="props">
          <q-td>
            <q-btn
              v-if="props"
              color="negative"
              icon="delete"
              dense
              round
              @click="removerUnidade(props.row.id)"
            />
          </q-td>
        </template>

        <template #body-cell-finalizar="props">
          <q-td>
            <span v-if="props.row.pivot.finish == 1">SIM</span>
            <span v-else>NÃO</span>
          </q-td>
        </template>
      </q-table>
    </section>
  </main>
</template>

<script>
const columns = [
  {
    name: "name",
    label: "Nome",
    field: "id",
    align: "left",
  },
  {
    name: "contrato",
    label: "Contrato",
    field: "name",
    align: "left",
  },
  {
    name: "visualizar",
    label: "Visualizar",
    field: "vizualizar",
    align: "left",
  },
  {
    name: "finalizar",
    label: "Finalizar",
    field: "finalizar",
    align: "left",
  },
];

const columns2 = [
  {
    name: "name",
    label: "Nome",
    field: "id",
    align: "left",
  },
  {
    name: "nome",
    label: "Contrato",
    field: "name",
    align: "left",
  },

  {
    name: "finalizar",
    label: "Finalizar",
    field: "finalizar",
    align: "left",
  },

  {
    name: "remover",
    label: "Remover",
    field: "remover",
    align: "left",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRoute } from "vue-router";
import { ref, onMounted, computed, watch } from "vue";
export default {
  setup() {
    const store = useStore();
    const disable = ref(true);
    const rows = ref([]);
    const rows2 = ref([]);
    const route = useRoute();
    const filtrar = ref("");
    const filtrar2 = ref("");
    const quasar = useQuasar();
    const id = route.params.id;

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });

    const getUnidades = async (page = 0, rowsPerPage = 15) => {
      disable.value = true;
      try {
        let response = await store.dispatch("user/getUnidades", {
          vendor_id: store.state.org.unidadeData.id,
          page,
          search: filtrar.value,
          per_page: rowsPerPage,
        });

        rows.value = response.data.results.data;

        pagination.value.page = response.data.results.current_page;
        pagination.value.rowsPerPage = response.data.results.per_page;
        pagination.value.rowsNumber = response.data.results.total;

        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getUnidades);

    const getUnidadesUser = async () => {
      disable.value = true;
      try {
        let response = await store.dispatch("user/getUserEspecifico", {
          id,
        });

        rows2.value = response.data.model.vendors;

        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getUnidadesUser);

    const vizualizarUnidade = async (vendor_id) => {
      try {
        await store.dispatch("user/vincularUnidade", {
          id,
          vendor_id,
          finish: 0,
        });
        quasar.notify({
          message: "Unidade vinculada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getUnidades();
        getUnidadesUser();
      } catch (error) {
        quasar.notify({
          message: "Erro a o modificar unidade",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const finalizarUnidade = async (vendor_id) => {
      try {
        await store.dispatch("user/vizualizarFinalizarUnidades", {
          id,
          vendor_id,
          finish: 1,
        });

        getUnidades();
        getUnidadesUser();
        quasar.notify({
          message: "Unidade finalizada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro a o modificar unidade",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const removerUnidade = async (vendor_id) => {
      try {
        await store.dispatch("user/removerUnidade", {
          id,
          vendor_id,
        });

        getUnidades();
        getUnidadesUser();
        quasar.notify({
          message: "Unidade removida com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro a o modificar unidade",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const handleRequest = async (props) => {
      getUnidades(props.pagination.page, props.pagination.rowsPerPage);
    };

    watch(
      () => filtrar.value,
      () => {
        getUnidades();
      }
    );

    watch(
      () => store.state.org.unidadeData.id,
      () => {
        getUnidades();
      }
    );

    return {
      rows,
      disable,
      filtrar,
      columns,
      columns2,
      rows2,
      handleRequest,
      getUnidades,
      pagination,
      vizualizarUnidade,
      finalizarUnidade,
      filtrar2,
      id,
      removerUnidade,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
</style>
